module.exports = __webpack_public_path__ + "static/media/drain-field.e2a69066.jpg";